import {InferType, object, string} from 'yup';

export const GiftCardEntrySchema = object({
  number: string().required('Gift Card Number is required'),
  pin: string().required('PIN is required'),
});

export type GiftCardEntryData = InferType<typeof GiftCardEntrySchema>;
